// @ts-nocheck
import { Badge } from "@/components/ui/badge";
import { Clapperboard, Disc3, List, Mic2, Music2, Tv } from "lucide-react";

export const truncateText = (text:string, cutoff:number) => {
        if(text){
            if(text.length > cutoff){
                text = text.slice(0,cutoff+1) + "...";
            }
        }
        return text;
    }

export const matchListTag = (tagText:string) => {
    const tagSelections = [
        { value: "peak", label: "Peak", color:"bg-violet-800" },
        { value: "weird", label: "Weird", color:"bg-emerald-800" },
        { value: "funny", label: "Funny", color:"bg-yellow-700" },
        { value: "what is that melody?!", label: "What is that melody?!", color:"bg-indigo-800" },
        { value: "artsy", label: "Artsy", color:"bg-rose-800" },
        { value: "fact", label: "Fact", color:"bg-blue-800" },
        { value: "random", label: "Random", color:"bg-red-800" },
        { value: "current", label: "Current", color:"bg-teal-800" },
        { value: "inspiring", label: "Inspiring", color:"bg-pink-600" },
        { value: "chill", label: "Chill", color:"bg-blue-900" },
        { value: "hype", label: "Hype", color:"bg-orange-600" },
        { value: "maidenless", label: "Maidenless", color:"bg-fuchsia-900" },
        { value: "allergic to grass", label: "Allergic to grass", color:"bg-lime-900" },
    ]

    let matchedTag;

    matchedTag = tagSelections.find(tag => tag.value === tagText) ? 
    tagSelections.find(tag => tag.value === tagText) : false;

    if(matchedTag){
        return(
        <Badge className={`${matchedTag.color}`}>
            {matchedTag.label}
        </Badge>
    );
    }
    else{
        return null;
    }

}

export const mediaTypeIcon = (mediaType:string) => {
    let icon = null;

    switch (mediaType) {
        case "albums":
            icon = <Disc3 />;
            break;

        case "shows":
            icon = <Tv />;
            break;
    
        case "movies":
            icon = <Clapperboard />;
            break;
        case "songs":
            icon = <Music2 />;
            break;
        case "artists":
            icon = <Mic2 />;
            break;
        case "list":
            icon = <List />;
            break;
        default:
            break;
    }

    return icon;
}

